<template>
    <legal-document-layout title="Privacy Policy" :version="version">
        <div v-if="policy" v-html="policy" class="prose prose-sm sm:prose max-w-none"></div>
        <p v-else class="text-sm text-red-600">
            Privacy Policy failed to load. Please refresh the page or contact support.
        </p>
    </legal-document-layout>
</template>

<script>
import LegalDocumentLayout from '@/Layouts/LegalDocumentLayout.vue';

export default {
    name: 'PrivacyPolicy',
    components: {
        LegalDocumentLayout,
    },
    props: {
        policy: { type: String, default: null },
        version: { type: String, default: null },
    },
};
</script>
